import { render } from "./LocaleSwitcher.vue?vue&type=template&id=5cc4ccd9"
import script from "./LocaleSwitcher.vue?vue&type=script&lang=js"
export * from "./LocaleSwitcher.vue?vue&type=script&lang=js"

import "./LocaleSwitcher.vue?vue&type=style&index=0&id=5cc4ccd9&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__